import { Component, OnInit, Input, Output, EventEmitter, ViewChild, OnDestroy, TemplateRef, ElementRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ResourcesService } from '@shared/services/resources.service';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { BaseService, ErrorService, UsersService } from '@shared/services';
import { MatSort } from '@angular/material/sort';
import { SelectionModel } from '@angular/cdk/collections';
import { first, takeUntil, tap } from 'rxjs/operators';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { LocalizationComponent } from 'app/layout/localization/localization.component';
import { Guid } from 'guid-typescript';
import { MenuItem } from 'primeng/api';
import { COMMA, E, ENTER } from '@angular/cdk/keycodes';
import swal from 'sweetalert2';
import { MasterPageLayoutComponent } from '../master-page-layout/master-page-layout.component';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '@environment/environment';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { MatHeaderRow, MatHeaderRowDef, MatTable, MatTableDataSource } from '@angular/material/table';


interface FilterObject {
    name?: string | null;
    assetcode?: string | null;
    active?: boolean | null;
    searchValue?: string | null;
}

export type ExportFormat = 'excel' | 'pdf';
@Component({
  selector: 'app-amenities',
  templateUrl: './amenities.component.html',
  styleUrls: ['./amenities.component.scss']
})
export class AmenitiesComponent implements OnInit, OnDestroy {
    filterObj: FilterObject = {
        name: null,
        assetcode: null,
        active: null,
        searchValue: ''
    };
    applyAdvancedFilter() {
        //debugger
        this.dataSource.filter = JSON.stringify(this.filterObj);
       
    }
    searchValueChange(searchValue) {
        //debugger
        this.filterObj.searchValue = searchValue;
        this.applyAdvancedFilter();
    }
    items: MenuItem[];
    loading = true;
    constructor(
        private translate: TranslateService,
        public router: Router,
        public route: ActivatedRoute,
        private modalService: BsModalService,
        private _resourceService: ResourcesService,
        private fb: FormBuilder,
        private _errorService: ErrorService,
        private _baseService: BaseService,
        private sanitizer: DomSanitizer,
     
    ) {}
    private _unsubscribeAll$ = new Subject<boolean>();

    searchValue = '';
    changeNewContant = false;
    laddaSearchProgress: boolean | number = false;
    newasset = false;
    assetsList = [];
    @Input('masterFile')
    masterFile = true;
    @Output('selectedAssets')
    selectedAssets: EventEmitter<any> = new EventEmitter<any>();
    formType = 'add';
    @ViewChild('formAddEditModal', { static: true }) formModal: TemplateRef<any>;
    @ViewChild('exportModal', { static: true }) exportModal: TemplateRef<any>;
    @ViewChild('filterModal', { static: true }) filterModal: TemplateRef<any>;
    modalRef: BsModalRef | null;

    @ViewChild(MatSort, { static: true }) sort: MatSort;
    displayedColumns: string[] = ['select', 'assetcode','name', 'isvalid'];
    dataSource = new MatTableDataSource([]);
    selection = new SelectionModel(true, []);
    currentContact;
    selectedassets = [];
    assetForm: FormGroup;
    saveContant = false;
    fixedassetId = '1';
    cultureobj = [];
    list = [];

    selectedStatus = 'All';
    //statusList = [{ name: 'All' }, { name: 'Active' }, { name: 'Inactive' }];
    statusList = [
        {
            label: 'Active',
            value: true
        },
        {
            label: 'InActive',
            value: false
        }
    ];
    actionStatus = null;
    actionsList = [{ name: 'Action' }, { name: 'Activate' }, { name: 'Delete' }, { name: 'Inactivate' }];
    selectAction() {
        if (this.actionStatus === 'Activate') {
            this.changeStatus('A');
        }
        if (this.actionStatus === 'Delete') {
            this.delete();
        }
        if (this.actionStatus === 'Inactivate') {
            this.changeStatus('NA');
        }
        this.actionStatus = null;
    }

    setCheckboxValue(event, atrr) {
        this.changeNewContant = true;
        if (event.checked) {
            this.assetForm.get(atrr).setValue(true);
        } else {
            this.assetForm.get(atrr).setValue(false);
        }
    }

    changeContant() {
        this.selectedAssets.emit(this.selection.selected);
    }
    @ViewChild('nameLocalization') nameLocalization: LocalizationComponent;
    //@ViewChild(LocalizationComponent) culturname: LocalizationComponent;
    saveCult() {
        // this.cult.saveAddEditGeneric(this.list);
    }
    GetCultureobj(obj) {
        obj.forEach((element) => {
            this.cultureobj.push(element);
        });
    }
    canAddCult = false;

    deleteSelected() {
        if (this.selection.selected.length == 0) {
            this.newMessage(60, 'error');
        } else {
            this.newMessage(9, 'delete');
        }
    }
    applyfilterStatus() {
        debugger
        if (this.selectedStatus === 'Active') {
            this.filterStatus(true);
        }
        if (this.selectedStatus === 'Inactive') {
            this.filterStatus(false);
        }
        if (this.selectedStatus === 'All') {
            this.filterStatus('');
        }
    }
    Edit(row) {
        this.formType = 'edit';
        if(row.isvalid){
            this.elementState = 'Activate'
        }
        else{
            this.elementState = 'Inactivate'
        }
        console.log("row", row);
        this.canAddCult = true;
        this.initForm();
        this.getById(row.fixedassetid);
        this.currentFiexedAssetId = row.fixedassetid;
        this.openModal();
    }
    AddNewItem() {
        this.formType = 'add';
        this.canAddCult = false;
        this.initForm();
        this.initEntityForm();
        this.previewUrl = null;
        this.openModal();
    }

    openModal() {
        this.cultureobj = [];
        this.list = [];
        const configs = {
            keyboard: false,
            ignoreBackdropClick: true,
            class: ' modal-lg modal-primary ModelPopUpLayoutFilterPopUps commenModel animated',
            animated: false
        };
        this.modalRef = this.modalService.show(this.formModal, configs);
    }

    openAnyModal(modal){
       
        const configs = {
            keyboard: false,
            ignoreBackdropClick: true,
            class: ' modal-lg modal-primary ModelPopUpLayoutFilterPopUps commenModel animated',
            animated: false
        };
        this.modalRef = this.modalService.show(modal, configs);
    }

    openfilterModal() {

        const configs = {
            keyboard: false,
            ignoreBackdropClick: true,
            class: ' modal-lg modal-primary ModelPopUpLayoutFilterPopUps commenModel animated',
            animated: false
        };
        this.modalRef = this.modalService.show(this.filterModal, configs);
    }
    closeAddEditModal() {
        if (!this.changeNewContant) {
            this.newasset = false;
            this.modalRef.hide();
        } else this.newMessage(144, 'ClosePopup');
    }

    ClosePopup() {
        this.newasset = false;
        this.modalRef.hide();
        this.changeNewContant = false;
    }

    //new code 
    readonly separatorKeysCodes: number[] = [ENTER, COMMA];
    addOnBlur = true;
    removable = true;
    visible = true;
    selectable = true;
    fruits: any[] = [];
    actionList = [
        { label: 'Delete', disabled: false },
        { label: 'Activate', disabled: false },
        { label: 'Inactivate', disabled: false }
      ];

      disableActivate = false;
disableInactivate = false;


updateActionAvailability() {
    const selected = this.selection.selected;
  
    if (!selected || selected.length === 0) {
      this.disableActivate = false;
      this.disableInactivate = false;
    } else {
      const allActive = selected.every(item => item.isvalid === true);
      const allInactive = selected.every(item => item.isvalid === false);
  
      if (allActive) {
        this.disableActivate = true;
        this.disableInactivate = false;
      } else if (allInactive) {
        this.disableActivate = false;
        this.disableInactivate = true;
      } else {
        this.disableActivate = true;
        this.disableInactivate = true;
      }
    }
      this.updateMenuItems();
  
    
  }


  updateMenuItems() {
    this.items = [
      {
        label: this.translate.instant('Delete'),
        icon: 'pi pi-times',
        disabled: false,
        command: () => {
          this.deleteSelected();
        }
      },
      {
        label: this.translate.instant('Activate'),
        icon: 'pi pi-check',
        disabled: this.disableActivate,
        command: () => {
          this.activeSelectedFiexedAsset();
        }
      },
      {
        label: this.translate.instant('Deactivate'),
        icon: 'pi pi-ban',
        disabled: this.disableInactivate,
        command: () => {
          this.inactiveSelectedFiexedAsset();
        }
      }
    ];
  }


   


    @ViewChild(MasterPageLayoutComponent) masterPageLayout: MasterPageLayoutComponent;
    toggleAdvancedFilter() {
        if (this.masterPageLayout) {
          this.masterPageLayout.showDialog = !this.masterPageLayout.showDialog;
        }
      }


    openAddResource(){

    }

    addfilter(event){

    }
    DeleteResource(){

    }

    IsRoleResource(row){

    }
         
    elementState : string='Activate'
    toggleElementState(){
        if(this.elementState == 'Activate'){
            this.elementState = 'Inactivate'
            this.assetForm.get('isvalid').setValue(false);
        }
        else{
            this.elementState = 'Activate'
            this.assetForm.get('isvalid').setValue(true);

        }
        console.log( this.assetForm.get('isvalid').value);
    }
    
    // image section 
        @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>; // Get reference to file input
        
        openFileDialog() {
          console.log("clicked");
          if (this.fileInput) {
            this.fileInput.nativeElement.click();
          }
        }
        
        
      imageForm: FormGroup;
      fileName: string = '';
      file: File | null = null;
      previewUrl: string | ArrayBuffer | SafeResourceUrl | null = null;
    
      isInvalidSize: boolean = false;
    isInvalidType: boolean = false;
    
    onFileChange(event: any) {
        //debugger
        const file = event.target.files[0];
        // Reset error states
        this.isInvalidSize = false;
        this.isInvalidType = false;
      
        if (file) {
          this.isInvalidSize = !this.validateFileSize(file);
          this.isInvalidType = !this.validateFileType(file);
      
          if (!this.isInvalidSize && !this.isInvalidType) {
            this.file = file;
            this.fileName = file.name;
            this.imageForm.patchValue({ imageFile: file });
      
            // Preview the image
            const reader = new FileReader();
            
            //this.upload(file);
            reader.onload = () => {
              // Sanitize the URL
              const unsafeUrl = reader.result as string;
              this.previewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(unsafeUrl);
              this.imageForm.get('imageName')?.setValue(this.fileName);
             
              // After preview is set, now update the resourceForm
             // this.resourceForm.patchValue({ photo: file });
            };
            reader.readAsDataURL(file);
          } else {
            this.file = null;
            this.fileName = '';
            this.previewUrl = null;
            this.imageForm.get('imageName')?.setValue('');
            this.assetForm.patchValue({ photo: null });
          }
        }
      }
    
    
    
      validateFileType(file: File) {
        const allowedTypes = ['image/png', 'image/jpeg', 'image/svg+xml'];
        return allowedTypes.includes(file.type);
      }
    
      validateFileSize(file: File) {
        return file.size <= 2 * 1024 * 1024; // 2 MB limit
      }
    
      removeFile() {
        this.file = null;
        this.fileName = '';
        this.previewUrl = null;
        this.imageForm.patchValue({ imageFile: null });
        this.imageForm.get('imageName')?.setValue('');
        
        // Also clear the resource form photo
        this.assetForm.patchValue({ photo: null });
      }
      
      initEntityForm() {
        this.imageForm = this.fb.group({
          imageName: ['', Validators.required],
          imageFile: [null, [Validators.required, this.validateFileType, this.validateFileSize]]
        });
      }
    
       onSubmit() {
          if (this.imageForm.valid && this.file) {
            const formData = new FormData();
        
            // Get the new filename from the input field
            const newFileName = this.imageForm.get('imageName')?.value || this.file.name;
        
            // Create a new file object with the user-specified filename
            const renamedFile = new File([this.file], newFileName, { type: this.file.type });
        
            formData.append('imageName', newFileName);
            formData.append('file', renamedFile);
        
            // ✅ Pass both formData and fileName
            this.uploadFile(formData, newFileName);
          }
        }
        
        uploadFile(formData: FormData, fileName: string): Observable<any> {
            return this._baseService.uploadImg(formData).pipe(
              tap((response) => {
                const mediaUrl = environment.AttachmentUrl + response.fileName;
                this.assetForm.get('photo')?.setValue(mediaUrl);
                this.previewUrl = mediaUrl;
              })
            );
          }
    
    
// async Export(): Promise<void> {
//   const fileName = 'exported-data.xlsx';
//   const dataToExport = this.dataSource.filteredData;
  
//   // Optional: map only selected columns
//   const exportData = dataToExport.map(item => ({
//     Name: item.name,
//     Code: item.assetcode,
//     Status: item.isvalid ? 'Active' : 'Inactive'
//   }));
  
//   const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);
//   const workbook: XLSX.WorkBook = {
//     Sheets: { data: worksheet },
//     SheetNames: ['data']
//   };
  
//   const excelBuffer: any = XLSX.write(workbook, {
//     bookType: 'xlsx',
//     type: 'array'
//   });
  
//   const blob: Blob = new Blob([excelBuffer], {
//     type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
//   });
  
//   // Check if File System Access API is supported
//   if ('showSaveFilePicker' in window) {
//     try {
//       const fileHandle = await (window as any).showSaveFilePicker({
//         suggestedName: fileName,
//         types: [{
//           description: 'Excel files',
//           accept: {
//             'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx']
//           }
//         }]
//       });
      
//       const writable = await fileHandle.createWritable();
//       await writable.write(blob);
//       await writable.close();
      
//       console.log('File saved successfully!');
//     } catch (error) {
//       if (error.name !== 'AbortError') {
//         console.error('Error saving file:', error);
//         // Fallback to FileSaver
//         FileSaver.saveAs(blob, fileName);
//       }
//     }
//   } else {
//     // Fallback for browsers that don't support File System Access API
//     FileSaver.saveAs(blob, fileName);
//   }
// }



          // import 

        
          
        //   onFileSelected(event: any): void {
        //     const file: File = event.target.files[0];
        //     if (file) {
        //       const reader: FileReader = new FileReader();
              
        //       reader.onload = (e: any) => {
        //         const data: Uint8Array = new Uint8Array(e.target.result);
        //         const workbook: XLSX.WorkBook = XLSX.read(data, { type: 'array' });
                
        //         const sheetName = workbook.SheetNames[0];
        //         const worksheet = workbook.Sheets[sheetName];
        //         const rawData = XLSX.utils.sheet_to_json(worksheet, { defval: '' });
                
        //         // Transform Excel data to match your DTO format
        //         const transformedData = (rawData as ExcelRow[]).map((item) => ({
        //           fixedassetid: null, // Convert to string to match DTO
        //           assetcode: item.Code || '',
        //           name: item.Name || '',
        //           description: '', // Default empty string for missing fields
        //           icon: '',
        //           photo: '',
        //           isvalid: item.Status?.toLowerCase() === 'active',
        //         }));
                
        //         // Apply to table for display
        //         this.dataSource.data = transformedData;
        //         this.saveFixedAssetsBatch(transformedData); 
        //         // Call API to save the data
        //        // this.saveFixedAssets(transformedData);
        //       };
              
        //       reader.readAsArrayBuffer(file);
        //     }
        //   }

        //   saveFixedAssetsBatch(assets: FixedassetsDto[]){
        //      if (!assets || assets.length === 0) {
        //      console.log('No assets to save');
        //      return;
        //         }

        //         this._resourceService
        //             .addfixedassetbatch(assets)
        //             .pipe(takeUntil(this._unsubscribeAll$), first())
        //             .subscribe(
        //                 (result) => {
        //                     if (result.isSuccess) {
        //                       this.getList();
        //                     } else{
        //                         console.log("saved fail");
        //                     }
                           
        //                 },
        //                 (error) => {
        //                     this.laddaSearchProgress = false;
        //                 }
        //             );
        //   }

          selectedExportFormat : any;
    
        async Export(format: ExportFormat = 'excel'): Promise<void> {
  const dataToExport = this.dataSource.filteredData;
  
  // Optional: map only selected columns
  const exportData = dataToExport.map(item => ({
    Name: item.name,
    Code: item.assetcode,
    Status: item.isvalid ? 'Active' : 'Inactive'
  }));

  if (format === 'excel') {
    await this.exportToExcel(exportData);
  } else if (format === 'pdf') {
    await this.exportToPDF(exportData);
  }
}

private async exportToExcel(data: any[]): Promise<void> {
  const fileName = 'Amenities.xlsx';
  
  const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
  const workbook: XLSX.WorkBook = {
    Sheets: { data: worksheet },
    SheetNames: ['data']
  };
  
  const excelBuffer: any = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array'
  });
  
  const blob: Blob = new Blob([excelBuffer], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
  });
  
  await this.saveFile(blob, fileName, 'Excel files', {
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx']
  });
}

private async exportToPDF(data: any[]): Promise<void> {
  const fileName = 'Amenities.pdf';
  
  // Create PDF document
  const doc = new jsPDF();
  
  // Add title
  doc.setFontSize(16);
  doc.text('Amenities Exported Data Report', 14, 20);
  
  // Add date
  doc.setFontSize(10);
  doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 30);
  
  // Prepare table data
  const tableColumns = ['Name', 'Code', 'Status'];
  const tableRows = data.map(item => [
    item.Name,
    item.Code,
    item.Status
  ]);
  
  // Add table
  autoTable(doc, {
    head: [tableColumns],
    body: tableRows,
    startY: 40,
    styles: {
      fontSize: 9,
      cellPadding: 3,
    },
    headStyles: {
      fillColor: [63, 81, 181], // Material Blue
      textColor: 255,
      fontStyle: 'bold'
    },
    alternateRowStyles: {
      fillColor: [245, 245, 245]
    },
    margin: { top: 40 }
  });
  
  // Convert to blob
  const pdfBlob = doc.output('blob');
  
  await this.saveFile(pdfBlob, fileName, 'PDF files', {
    'application/pdf': ['.pdf']
  });
}

private async saveFile(
  blob: Blob, 
  fileName: string, 
  description: string, 
  accept: Record<string, string[]>
): Promise<void> {
  // Check if File System Access API is supported
  if ('showSaveFilePicker' in window) {
    try {
      const fileHandle = await (window as any).showSaveFilePicker({
        suggestedName: fileName,
        types: [{
          description: description,
          accept: accept
        }]
      });
      
      const writable = await fileHandle.createWritable();
      await writable.write(blob);
      await writable.close();
      this.ClosePopup()
      //console.log('File saved successfully!');
    } catch (error) {
      if (error.name !== 'AbortError') {
        console.error('Error saving file:', error);
        // Fallback to FileSaver
        FileSaver.saveAs(blob, fileName);
      }
    }
  } else {
    // Fallback for browsers that don't support File System Access API
    FileSaver.saveAs(blob, fileName);
  }
}



        @ViewChild('importModal', { static: true }) importModal: TemplateRef<any>;
//@ViewChild('fileInput') fileInput: ElementRef;

// Properties for import functionality
selectedFile: File | null = null;
isProcessing = false;
importCompleted = false;
progressPercentage = 0;
processedItems = 0;
totalItems = 0;
batchSize = 50; // Number of items to process in each batch
  
importData: any[] = [];
errorItems: any[] = [];
validItems: any[] = [];
  
private processingTimeout: any;
private isCancelled = false;


// Method to open the import modal
openImportModal() {
  this.resetImportState();
  const configs = {
    keyboard: false,
    ignoreBackdropClick: true,
    class: 'modal-lg modal-primary ModelPopUpLayoutFilterPopUps commenModel animated',
    animated: false
  };
  this.modalRef = this.modalService.show(this.importModal, configs);
}

// Method to close the import modal
closeImportModal(): void {
  if (this.isProcessing) {
    if (confirm('Import is in progress. Are you sure you want to cancel?')) {
      this.cancelImport();
    } else {
      return;
    }
  }
  this.modalRef?.hide();
  this.resetImportState();
}

// Reset import state
resetImportState(): void {
  this.selectedFile = null;
  this.isProcessing = false;
  this.importCompleted = false;
  this.progressPercentage = 0;
  this.processedItems = 0;
  this.totalItems = 0;
  this.importData = [];
  this.errorItems = [];
  this.validItems = [];
  this.isCancelled = false;
}

// Handle file selection
onFileSelected(event: any): void {
  const file: File = event.target.files[0];
  if (file) {
    this.selectedFile = file;
    
    const reader: FileReader = new FileReader();
    
    reader.onload = (e: any) => {
      try {
        const data: Uint8Array = new Uint8Array(e.target.result);
        const workbook: XLSX.WorkBook = XLSX.read(data, { type: 'array' });
        
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const rawData = XLSX.utils.sheet_to_json(worksheet, { defval: '' });
        
        // Transform Excel data to match your DTO format
        this.importData = (rawData as any[]).map((item, index) => ({
          fixedassetid: null,
          assetcode: item.Code || '',
          name: item.Name || '',
          description: '', // Default empty string for missing fields
          icon: '',
          photo: '',
          isvalid: item.Status?.toLowerCase() === 'active',
          _rowIndex: index + 2 // Excel row number (accounting for header row)
        }));
        
        this.validateData();
      } catch (error) {
       // swal.fire('Error', 'Failed to parse Excel file. Please check the file format.', 'error');

        this.selectedFile = null;
      }
    };
    
    reader.readAsArrayBuffer(file);
  }
}

// Display file size
getFileSizeDisplay(): string {
  if (!this.selectedFile) return '';
  
  const fileSizeKB = this.selectedFile.size / 1024;
  if (fileSizeKB < 1024) {
    return `${fileSizeKB.toFixed(2)} KB`;
  } else {
    return `${(fileSizeKB / 1024).toFixed(2)} MB`;
  }
}

// Validate imported data
validateData(): void {
  this.errorItems = [];
  this.validItems = [];
  
  this.importData.forEach((item: any) => {
    let isValid = true;
    const rowError: any = {
      rowNumber: item._rowIndex,
      assetcode: item.assetcode,
      error: ''
    };
    
    // Basic validation
    if (!item.assetcode) {
      rowError.error += 'Asset code is required. ';
      isValid = false;
    }
    if(item.assetcode.length > 50){
      rowError.error += 'Asset code max length is 50 character';
      isValid = false;
    }
    
    if (!item.name) {
      rowError.error += 'Name is required. ';
      isValid = false;
    }
    if(item.name.length > 100){
      rowError.error += 'name max length is 100 character';
      isValid = false;
    }
    
    // Add the item to the appropriate array
    if (isValid) {
      this.validItems.push(item);
    } else {
      this.errorItems.push(rowError);
    }
  });
  

}

// Start the import process
startImport(): void {
  debugger
  if (this.importData.length === 0) {
   // swal.fire('Error', 'No data to import.', 'error');

    return;
  }

  if(this.validItems.length ===0){
    this.newMessage(229,'');

    return;
  }
  
  const dataToImport = this.errorItems.length > 0 ? this.validItems : this.importData;
  this.totalItems = dataToImport.length;
  this.processedItems = 0;
  this.progressPercentage = 0;
  this.isProcessing = true;
  this.isCancelled = false;
  
  // Process in batches to avoid UI freezing
  this.processBatch(dataToImport, 0);
}

processBatch(data: any[], startIndex: number): void {
  if (this.isCancelled) return;

  const endIndex = Math.min(startIndex + this.batchSize, data.length);
  const batch = data.slice(startIndex, endIndex);

  this.saveFixedAssetsBatch(batch).then((response) => {
    // ✅ Update processedItems using backend-confirmed data
    this.processedItems += response?.data?.length || 0;

    this.progressPercentage = Math.round((this.processedItems / this.totalItems) * 100);

    if (endIndex < data.length && !this.isCancelled) {
      this.processingTimeout = setTimeout(() => {
        this.processBatch(data, endIndex);
      }, 100);
    } else if (!this.isCancelled) {
      this.completeImport();
    }
  }).catch((error) => {
    swal.fire('Import Error', 'Error saving batch: ' + error.message, 'error');
    this.isProcessing = false;
  });
}

  insertedItems: any[] = [];
skippedItems: any[] = [];

// Save a batch of fixed assets
saveFixedAssetsBatch(batch: any[]): Promise<Result<any[], any>> {
  return new Promise((resolve, reject) => {
    this._resourceService.addfixedassetbatch(batch).subscribe({
      next: (response) => {
        this.insertedItems = response.data.inserted || [];
        this.skippedItems = response.data.skipped || [];

        // update datasource with inserted
        if (this.dataSource && this.dataSource.data && this.insertedItems.length > 0) {
          this.dataSource.data = [...this.dataSource.data, ...this.insertedItems];
        }

        // mark import complete
        this.importCompleted = true;

        resolve(response);
      },
      error: (err) => reject(err)
    });
  });
}

// Continue with only valid items
continueWithValidItems(): void {
  if (this.validItems.length === 0) {
    swal.fire('Error', 'No valid items to import.', 'error');

    return;
  }
  
  this.startImport();
}

// Cancel the import process
cancelImport(): void {
  this.isCancelled = true;
  if (this.processingTimeout) {
    clearTimeout(this.processingTimeout);
  }
  this.isProcessing = false;
  //swal.fire('Import Cancelled', 'Import cancelled.', 'warning');

}

// Complete the import process
completeImport(): void {
  this.isProcessing = false;
  this.importCompleted = true;
  //swal.fire('Import Complete', `Successfully imported ${this.processedItems} items.`, 'success');

  
  // Refresh your data if needed
  this.getList();
  //this.loadData(); // Call your existing method to reload the data
}

// Update your import button click handler
onImportClick(): void {
  this.openImportModal();
}

tamplateloading = false;
 downloadTemplate() {
  this.tamplateloading = true;
  this._resourceService
    .downloadAmenitiesTemplate()
    .pipe(takeUntil(this._unsubscribeAll$), first())
    .subscribe((blob: Blob) => {
      const link = document.createElement('a');
      const url = window.URL.createObjectURL(blob);
      link.href = url;
      link.download = 'AmenitiesTemplate.xlsx';
      link.click();
      window.URL.revokeObjectURL(url);
      this.tamplateloading = false;
    });
}


          // inactive part 
        currentFiexedAssetId : any;

          inactiveFiexedAsset(){
           
            let ids;
            ids = [this.currentFiexedAssetId]

            this._resourceService
            .Inactivefixedassets(ids)
            .pipe(takeUntil(this._unsubscribeAll$), first())
            .subscribe(
                (result) => {
                    if (result.isSuccess) {
                        this.newMessage(54, '');
                    } else {
                        this.newMessage(55, '');
                    }
                    this.selection = new SelectionModel(true, []);
                    this.getList();
                    this.currentFiexedAssetId = null;
                    this.laddaSearchProgress = false;
                    this.changeNewContant = false;
                    this.saveContant = false;
                    this.elementState = null;
                    this.closeAddEditModal();
                },
                (error) => {
                    this.laddaSearchProgress = false;
                }
            );

          }
          

          activeFiexedAsset(){
           
            let ids;
            ids = [this.currentFiexedAssetId]

            this._resourceService
            .activefixedassets(ids)
            .pipe(takeUntil(this._unsubscribeAll$), first())
            .subscribe(
                (result) => {
                    if (result.isSuccess) {
                        this.newMessage(54, '');
                    } else {
                        this.newMessage(55, '');
                    }
                    this.selection = new SelectionModel(true, []);
                    this.getList();
                    this.currentFiexedAssetId = null;
                    this.laddaSearchProgress = false;
                    this.changeNewContant = false;
                    this.saveContant = false;
                    this.elementState = null
                    this.closeAddEditModal();
                },
                (error) => {
                    this.laddaSearchProgress = false;
                }
            );

          }
          

         
          inactiveSelectedFiexedAsset() {
            if (this.selection.selected.length==0) {
            this.newMessage(60, 'error');
        } else{
            let idsToInactive: number[] = [];
        
            // Collect selected fixed asset IDs
            if (this.selection && this.selection.selected.length > 0) {
                const fixedassetIds = this.selection.selected.map(item => item.fixedassetid);
                idsToInactive = [...idsToInactive, ...fixedassetIds];
            }
        
            // If there are IDs selected, confirm before inactivating
            if (idsToInactive.length > 0) {
                swal.fire({
                    title: `Are you sure you want to deactivate the selected items?`,
                    type: "question", // ✅ Use 'type' for SweetAlert v1 or wrappers
                    showCancelButton: true,
                    confirmButtonText: "Yes",
                    cancelButtonText: "No",
                    confirmButtonColor: "#6FBDC1"
                }).then((result) => {
                    if (result.value) {
                        this._resourceService
                            .Inactivefixedassets(idsToInactive)
                            .pipe(takeUntil(this._unsubscribeAll$), first())
                            .subscribe(
                                (result) => {
                                    if (result.isSuccess) {
                                        this.newMessage(56, '');
                                    } else {
                                        this.newMessage(55, '');
                                    }
        
                                    // Reset UI states
                                    this.selection = new SelectionModel(true, []);
                                    this.getList();
                                    this.laddaSearchProgress = false;
                                    this.changeNewContant = false;
                                    this.saveContant = false;
        
                                    // Optionally reset the action selection
                                    this.selectedAction = null;
                                },
                                (error) => {
                                    this.laddaSearchProgress = false;
                                }
                            );
                    }
                });
            }
          }
        }

          
        activeSelectedFiexedAsset() {
          if (this.selection.selected.length==0) {
            this.newMessage(60, 'error');
        } else{
            let idsToActive: number[] = [];
        
            // Collect selected fixed asset IDs
            if (this.selection && this.selection.selected.length > 0) {
                const fixedassetIds = this.selection.selected.map(item => item.fixedassetid);
                idsToActive = [...idsToActive, ...fixedassetIds];
            }
        
            // If there are IDs selected, confirm before inactivating
            if (idsToActive.length > 0) {
                swal.fire({
                    title: `Are you sure you want to activate the selected items?`,
                    type: "question", // ✅ Use 'type' for SweetAlert v1 or wrappers
                    showCancelButton: true,
                    confirmButtonText: "Yes",
                    cancelButtonText: "No",
                    confirmButtonColor: "#6FBDC1"
                }).then((result) => {
                    if (result.value) {
                        this._resourceService
                            .activefixedassets(idsToActive)
                            .pipe(takeUntil(this._unsubscribeAll$), first())
                            .subscribe(
                                (result) => {
                                    if (result.isSuccess) {
                                        this.newMessage(56, '');
                                    } else {
                                        this.newMessage(55, '');
                                    }
        
                                    // Reset UI states
                                    this.selection = new SelectionModel(true, []);
                                    this.getList();
                                    this.laddaSearchProgress = false;
                                    this.changeNewContant = false;
                                    this.saveContant = false;
        
                                    // Optionally reset the action selection
                                    this.selectedAction = null;
                                },
                                (error) => {
                                    this.laddaSearchProgress = false;
                                }
                            );
                    }
                });
            }
          }
        }
        
        

          selectedAction: string | null = null;
          onActionChange(action: any) {
            switch (action.label) {
              case 'Delete':
                this.delete();
                break;
              case 'Inactivate':
                this.inactiveSelectedFiexedAsset();
                break;
              case 'Activate':
                this.activeSelectedFiexedAsset();
              default:
                break;
            }
             this.selectedAction = null;
          }
          

    ////////////

    filterStatus(status) {
        const newList = [];
        this.dataSource = new MatTableDataSource(this.assetsList);

        if (status === '') {
        } else {
            this.dataSource.filteredData.forEach((element) => {
                if (element.isvalid === status) {
                    newList.push(element);
                }
            });
            this.dataSource = new MatTableDataSource(newList);
        }
        this.dataSource.sort = this.sort;

        this.applyFilter(this.searchValue);
    }
    getById(contactId) {
        this._resourceService
            .getfixedassetbyidwithnocheck(contactId)
            .pipe(takeUntil(this._unsubscribeAll$), first())
            .subscribe(
                (result) => {
                    this.currentContact = result.data;
                    const controls = this.assetForm.controls;
                    Object.keys(controls).forEach((key) => {
                        if (this.currentContact[key] != null) {
                            this.assetForm.get(key).setValue(this.currentContact[key]);
                        }
                       
                        
                    });

                    // Handle image preview after form values are set
                const photoValue = this.assetForm.get('photo').value;
                if (photoValue) {
                    this.previewUrl = photoValue; // Make sure this is a valid image URL or base64
                } else {
                    this.previewUrl = null;
                }
                    this.changeNewContant = false;

                },
                (error) => {}
            );
    }
     // Set image preview if exists
   

    ngOnInit() {
      this.initializeMenuItems();
        // this.items = [
        //     // {label: 'Update', icon: 'pi pi-refresh', command: () => {
        //     //     this.update();
        //     // }},
        //     {
        //         label: this.translate.instant('Delete'),
        //         //icon: 'pi pi-times',
        //         command: () => {
        //             this.deleteSelected();
        //         }
        //     }
            // {label: 'Angular.io', icon: 'pi pi-info', url: 'http://angular.io'},
            // {separator:true},
            // {label: 'Setup', icon: 'pi pi-cog', routerLink: ['/setup']}
        //];

        this.getList();
        this.initForm();
        this.initEntityForm();
        this.assetForm.valueChanges.pipe(takeUntil(this._unsubscribeAll$)).subscribe((changes) => {
            this.changeNewContant = true;
        });

        this._errorService.currentAction
            .pipe(takeUntil(this._unsubscribeAll$))
            .subscribe((action) => this.actionMsg(action));
    }
    // subscription: Subscription = new Subscription();

    ngOnDestroy() {
        this._unsubscribeAll$.next(true);
        this._unsubscribeAll$.complete();
        // this.subscription.unsubscribe();
        if (this.modalRef) {
            this.modalRef.hide();
        }
    }
    getList() {
        this.searchValue = '';
        this._resourceService
            .getallfixedassets()
            .pipe(takeUntil(this._unsubscribeAll$), first())
            .subscribe((result) => {
                this.assetsList = result.data;
                this.dataSource = new MatTableDataSource(this.assetsList);
                this.dataSource.sort = this.sort;
                this.dataSource.sortingDataAccessor = (data: any, sortHeaderId: string): string => {
                if (typeof data[sortHeaderId] === 'string') {
                  return data[sortHeaderId].toLowerCase();
                }
                return data[sortHeaderId];
              };
                this.loading = false;
                //this.applyfilterStatus();
                this.dataSource.filterPredicate = function (data, filterObjectString: string): boolean {
                    debugger;
                    const filterObj: FilterObject = JSON.parse(filterObjectString);
                    const name = filterObj.name? filterObj.name.toLocaleLowerCase() : null;
                    const assetcode = filterObj.assetcode? filterObj.assetcode.toLocaleLowerCase() : null;
                    const status = filterObj.active;
                    const searchValue = filterObj.searchValue.trim().toLocaleLowerCase();
                    const dataStr = Object.keys(data)
                        .reduce((currentTerm: string, key: string) => {
                            return currentTerm + data[key] + '◬';
                        }, '')
                        ?.toLowerCase();

                    return (
                        (data.name?.toLowerCase().indexOf(name) !== -1 || name == null) &&
                        (data.assetcode?.toLowerCase().indexOf(assetcode) !== -1 || assetcode == null) &&
                        (data.isvalid === status || status === null) &&
                        (dataStr.trim()?.toLowerCase().indexOf(searchValue) !== -1 || searchValue == '')
                    );
                };
                this.applyAdvancedFilter();
                this.onFilterChange(this.selectedDisplayAction);
                //  //make default filter valid value only
                //  this.filterObj.active = true;
                //  this.applyAdvancedFilter();
            });
    }

    isAllSelected() {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.data.length;
        return numSelected === numRows;
    }

    masterToggle() {
        this.isAllSelected()
            ? this.selection.clear()
            : this.dataSource.data.forEach((row) => this.selection.select(row));
    }

    checkboxLabel(row): string {
        if (!row) {
            return `${this.isAllSelected() ? 'select' : 'deselect'} all`;
        }
        return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.email + 1}`;
    }

    applyFilter(filterValue: string) {
        // Update the search value in your filter object
        this.filterObj.searchValue = filterValue || '';
        
        // Apply the updated filter object
        this.applyAdvancedFilter();
    }

   
    private initForm(): void {
        const id = Guid.create();
        this.assetForm = this.fb.group({
            fixedassetid: new FormControl(id.toString()),
            assetcode: new FormControl(null, [Validators.required]),
            icon: new FormControl(null),
            photo: new FormControl(null),
            description: new FormControl(null),
            name: new FormControl(null, [Validators.required]),
            isvalid: new FormControl(true)
        });
    }
    setTumbnail(data) {
        this.assetForm.get('photo').setValue(data);
    }

    setFileName(data) {
        // console.log(data);
        this.assetForm.get('photo').setValue(data);
        this.changeNewContant = true;
    }
    seticonName(data) {
        // console.log(data);
        this.assetForm.get('icon').setValue(data);
        this.changeNewContant = true;
    }

    saveEditResource() {
        // debugger
       
         if (this.imageForm.valid && this.file) {
           const formData = new FormData();
           const newFileName = this.imageForm.get('imageName')?.value || this.file.name;
           const renamedFile = new File([this.file], newFileName, { type: this.file.type });
           formData.append('imageName', newFileName);
           formData.append('file', renamedFile);
       
           this.uploadFile(formData, newFileName).subscribe(() => {
             //debugger;
             // After successful upload, determine which function to call based on formType
            this.saveAddEdit();
           });
         } else {
           // No image uploaded or form not valid — determine which function to call based on formType
          this.saveAddEdit();
         }
       }
       

    saveAddEdit() {
        this.laddaSearchProgress = 1;
        const controls = this.assetForm.controls;
        Object.keys(controls).forEach((key) => {
            controls[key].markAsTouched();
        });
        if (this.assetForm.status === 'VALID') {
            this.saveContant = false;
            if (this.formType == 'add') {
                this._resourceService
                    .addfixedasset(this.assetForm.value)
                    .pipe(takeUntil(this._unsubscribeAll$), first())
                    .subscribe(
                        (result) => {
                            if (result.isSuccess) {
                                
                                this.newMessage(93, '');
                                this.changeNewContant = false;
                                this.closeAddEditModal();
                                // const dgwData = result.data;

                                //  this.cultureobj.forEach(element => {
                                //   element.masterItemId
                                //   =result.data
                                //   this.list.push(element);

                                // });
                                //   this.culturname.saveAddEditGeneric(this.cultureobj);
                            } else {
                                this.changeNewContant = true;
                                this.newMessage(230, '');
                            }
                            this.laddaSearchProgress = false;
                            this.getList();
                        },
                        (error) => {
                            this.laddaSearchProgress = false;
                        }
                    );
            } else {
                this._resourceService
                    .editfixedasset(this.assetForm.value)
                    .pipe(takeUntil(this._unsubscribeAll$), first())
                    .subscribe(
                        (result) => {
                            if (result.isSuccess) {
                                // const dgwData = result.data;
                                this.newMessage(4, '');
                                this.changeNewContant = false;
                                this.closeAddEditModal();
                            } else {
                                this.changeNewContant = false;
                                this.newMessage(77, '');
                            }
                            this.getList();
                            this.laddaSearchProgress = false;
                            this.changeNewContant = false;
                            this.saveContant = false;
                        },
                        (error) => {
                            this.laddaSearchProgress = false;
                        }
                    );
            }
        } else {
            this.saveContant = true;
            window.scrollTo(0, 0);
            this.laddaSearchProgress = false;
            this.changeNewContant = false;
            this.newMessage(3, '');
        }
        // this.modalRef.hide();
    }
    delete() {
        // Get selected items
        const selectedItems = this.selection.selected;
        
        // Check if items are selected
        if (selectedItems.length === 0) {
            // Optionally show a message that no items are selected
            return;
        }
        
       
        
        // Show confirmation dialog
        swal.fire({
            title: `Are you sure you want to delete selected items?`,
            type: "question",
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            confirmButtonColor: "#6FBDC1"
        }).then((result) => {
            // If user confirmed the delete
            if (result.value) {
                // Proceed with delete operation
                this._resourceService
                    .safedeletefixedassets(selectedItems.map((obj) => obj.fixedassetid))
                    .pipe(takeUntil(this._unsubscribeAll$), first())
                    .subscribe(
                        (result) => {
                            if (result.isSuccess) {
                                this.newMessage(54, '');
                            } else {
                                this.newMessage(55, '');
                            }
                            this.selection = new SelectionModel(true, []);
                            this.getList();
                            this.laddaSearchProgress = false;
                            this.changeNewContant = false;
                            this.saveContant = false;
                        },
                        (error) => {
                            this.laddaSearchProgress = false;
                        }
                    );
            }
        });
    }

    deleteItem(fixedassetidparam : any){
        let ids;
        ids = [fixedassetidparam]
        swal.fire({
            title: `Are you sure you want to delete this item?`,
            type: "question",
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: "No",
            confirmButtonColor: "#6FBDC1"
        }).then((result) => {
            // If user confirmed the delete
            if (result.value) {
                // Proceed with delete operation
                this._resourceService
                    .safedeletefixedassets(ids)
                    .pipe(takeUntil(this._unsubscribeAll$), first())
                    .subscribe(
                        (result) => {
                            if (result.isSuccess) {
                                this.newMessage(54, '');
                            } else {
                                this.newMessage(55, '');
                            }
                            this.selection = new SelectionModel(true, []);
                            this.getList();
                            this.laddaSearchProgress = false;
                            this.changeNewContant = false;
                            this.saveContant = false;
                        },
                        (error) => {
                            this.laddaSearchProgress = false;
                        }
                    );
            }
        });
    }

    changeStatus(data) {}
    actionMsg(data) {
        if (data !== '') {
            this[data]();
            this._errorService.action('');
        }
    }
    newMessage(id, action) {
        this._errorService.changeMessage({ id: id, action: action });
    }
    closeLocalizationPopup(localizationComponant) {
        localizationComponant.closeAddEditModal();
    }
    resetAllFilters(){
        this.filterObj = {
            name: null,
            assetcode: null,
            active: null,
            searchValue: ''
        };
       // this.applyAdvancedFilter();
    }

    initializeMenuItems() {
    this.items = [
      {
        label: this.translate.instant('Delete'),
        icon: 'pi pi-times',
        disabled: false,
        command: () => {
          this.deleteSelected();
        }
      },
      {
        label: this.translate.instant('Activate'),
        icon: 'pi pi-check',
        disabled: this.disableActivate,
        command: () => {
          this.activeSelectedFiexedAsset();
        }
      },
      {
        label: this.translate.instant('Deactivate'),
        icon: 'pi pi-ban',
        disabled: this.disableInactivate,
        command: () => {
          this.inactiveSelectedFiexedAsset();
        }
      }
    ];
  }

    filterList : any[] = ['Display All' , 'Active' , 'Inactive'];
    selectedDisplayAction: string = 'Active';
  onFilterChange(filterValue: string) {
  if (!filterValue || filterValue === 'Display All') {
    this.selectedDisplayAction = 'Display All';
    this.dataSource.data = [...this.assetsList];
  } else if (filterValue === 'Active') {
    this.selectedDisplayAction = 'Active';
    this.dataSource.data = this.assetsList.filter(item => item.isvalid === true);

  } else if (filterValue === 'Inactive') {
    this.selectedDisplayAction = 'Inactive';
    this.dataSource.data = this.assetsList.filter(item => item.isvalid === false);
  }
  this.dataSource.sortingDataAccessor = (data: any, sortHeaderId: string): string => {
                if (typeof data[sortHeaderId] === 'string') {
                  return data[sortHeaderId].toLowerCase();
                }
                return data[sortHeaderId];
              };
}





 ngAfterViewInit() {
        this.getTableConfig();
    }


    Gridcongid = { grid: 'Assets', windowRoute: 'fixedAssets' };

     @ViewChild('amenities', { read: MatTable }) AmenitiesTable: MatTable<any>;
        @ViewChild('amenitiesRow') MatRow!: MatHeaderRow;
      getTableConfig() {
        this._baseService
            .post(`GridConfig/GetGridCongif`, this.Gridcongid)
            .pipe(takeUntil(this._unsubscribeAll$), first())
            .subscribe((result) => {
                if (result.data != null && result.data.length > 0) {
                    let list = result.data
                    this.MatRow = result.data.map((obj) => obj.col);
                    //console.log(this.MatRow.nativeElement.getAttribute('matHeaderRowDef'))
                    console.log(this.AmenitiesTable._contentHeaderRowDefs.toArray());
                    this.AmenitiesTable._contentHeaderRowDefs.toArray()[0].columns = list.map((obj) => obj.col);
                    this.AmenitiesTable._contentRowDefs.toArray()[0].columns = list.map((obj) => obj.col);

                    this.AmenitiesTable.renderRows();
                }
            });
    }

    
   updateNewCol(event) {
  if (event) {
    // Always start with the "select" column
    let visibleCols = event.filter((e) => e.isShowen === true && e.col !== 'select');
    let colKeys = ['select', ...visibleCols.map((obj) => obj.col)];

    this.MatRow = colKeys;

    if (this.AmenitiesTable?._contentHeaderRowDefs?.length) {
      this.AmenitiesTable._contentHeaderRowDefs.toArray()[0].columns = colKeys;
    }

    if (this.AmenitiesTable?._contentRowDefs?.length) {
      this.AmenitiesTable._contentRowDefs.toArray()[0].columns = colKeys;
    }

    this.AmenitiesTable.renderRows();
  }
}


showDialog: boolean = false;
  toggleGridPopup(): void {
  this.showDialog = !this.showDialog;
}

// Translation properties
    //canAddCult: boolean = true;
    disable: boolean = false;
    titleCultureObj: any = null;
    descCultureObj: any = null;

// Translation methods
openTranslationPopup(columnName: string, masterItemId: any): void {
    if (columnName === 'name') {
        this.titleCultureObj = {
            columnName: columnName,
            masterItemId: masterItemId,
            originalTableName: 'fixedassets'
        };
    } else if (columnName === 'description') {
        this.descCultureObj = {
            columnName: columnName,
            masterItemId: masterItemId,
            originalTableName: 'fixedassets'
        };
    }
}

Isclosed(event: any): void {
    // Clear both culture objects
    this.titleCultureObj = null;
    this.descCultureObj = null;
    
    // Refresh data if needed after translation is saved
    if (event && event.saved) {
           this.getList();
    }
}



}


interface ExcelRow {
    Name: string;
    Code: string;
    Status: string;
  }
  
  interface FixedassetsDto {
    fixedassetid: string;
    assetcode: string;
    name: string;
    description: string;
    icon: string;
    photo: string;
    isvalid: boolean;
  }

  export interface Result<T, K> {
  isSuccess: boolean;
  errorCode: number;
  message: string;
  messageType: string;
  data: T | null;
  lookupData?: K;
}
